import { useEffect, useState } from "react"

//PrimeReact
import { Checkbox } from "primereact/checkbox"

//styling
import myStyles from "../../../styles/assessments/AssessmentScheduleForm.module.css"
import { useField } from "formik"
import { getCronTimeUtc } from "./scheduleHelpers"

export default function AssessmentScheduleWeekly({
  cronFieldName,
  timeValue,
  refreshCronStatement,
  disabled,
}) {
  const [field, , helpers] = useField(cronFieldName)

  const [monday, setMonday] = useState(false)
  const [tuesday, setTuesday] = useState(false)
  const [wednesday, setWednesday] = useState(false)
  const [thursday, setThursday] = useState(false)
  const [friday, setFriday] = useState(false)
  const [saturday, setSaturday] = useState(false)
  const [sunday, setSunday] = useState(false)

  useEffect(() => {
    if (field.value !== "") {
      var existingCron = field.value?.split(" ")

      if (existingCron.length === 5) {
        setMonday(existingCron[4].includes("MON"))
        setTuesday(existingCron[4].includes("TUE"))
        setWednesday(existingCron[4].includes("WED"))
        setThursday(existingCron[4].includes("THU"))
        setFriday(existingCron[4].includes("FRI"))
        setSaturday(existingCron[4].includes("SAT"))
        setSunday(existingCron[4].includes("SUN"))
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let timeValues = getCronTimeUtc(timeValue)

    //Default cron is week days
    let newCron = `${timeValues} * *`
    let selection = [
      { day: monday, cron: "MON" },
      { day: tuesday, cron: "TUE" },
      { day: wednesday, cron: "WED" },
      { day: thursday, cron: "THU" },
      { day: friday, cron: "FRI" },
      { day: saturday, cron: "SAT" },
      { day: sunday, cron: "SUN" },
    ]

    if (selection.filter((day) => day.day).length === 7) {
      newCron = `${newCron} *`
    } else if (
      selection.filter((day) => day.day).length <= 7 &&
      selection.filter((day) => day.day).length > 0
    ) {
      let selectedDays = selection
        .filter((day) => day.day)
        .map((day) => day.cron)

      newCron = `${newCron} ${selectedDays.join(",")}`
    } else {
      newCron = ""
    }

    helpers.setValue(newCron)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
    refreshCronStatement,
  ])

  return (
    <div className={myStyles.periodOptionContainer}>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={monday}
          onChange={(e) => {
            setMonday(e.checked)
          }}
          disabled={disabled}
        />
        Monday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={tuesday}
          onChange={(e) => {
            setTuesday(e.checked)
          }}
          disabled={disabled}
        />
        Tuesday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={wednesday}
          onChange={(e) => {
            setWednesday(e.checked)
          }}
          disabled={disabled}
        />
        Wednesday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={thursday}
          onChange={(e) => {
            setThursday(e.checked)
          }}
          disabled={disabled}
        />
        Thursday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={friday}
          onChange={(e) => {
            setFriday(e.checked)
          }}
          disabled={disabled}
        />
        Friday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={saturday}
          onChange={(e) => {
            setSaturday(e.checked)
          }}
          disabled={disabled}
        />
        Saturday
      </div>
      <div
        className={`${myStyles.periodOption} ${myStyles.periodWeeklyOption}`}
      >
        <Checkbox
          checked={sunday}
          onChange={(e) => {
            setSunday(e.checked)
          }}
          disabled={disabled}
        />
        Sunday
      </div>
    </div>
  )
}
